import { render, staticRenderFns } from "./ComponentTest.vue?vue&type=template&id=a06e327a&scoped=true"
import script from "./ComponentTest.vue?vue&type=script&lang=js"
export * from "./ComponentTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06e327a",
  null
  
)

export default component.exports